import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '../services/api-client';
import type { ProfileCandidateList, SavedProfile } from '../types/api';
import { searchKeys } from './use-searches';

export const profileKeys = {
  candidates: (searchId: string) => ['profiles', 'candidates', searchId] as const,
  saved: () => ['profiles', 'saved'] as const,
};

export function useProfileCandidates(searchId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: profileKeys.candidates(searchId ?? ''),
    enabled: Boolean(searchId) && enabled,
    queryFn: () => apiRequest<ProfileCandidateList>(`/searches/${searchId}/profiles`),
  });
}

export interface SelectProfilesInput {
  profileIds: string[];
  save: boolean;
}

/**
 * Efetiva a escolha. É o único caminho para coletar uma pesquisa por pessoa —
 * não existe rota que resolva identidade sozinha (RF-D04).
 */
export function useSelectProfiles(searchId: string) {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (input: SelectProfilesInput) =>
      apiRequest<{ searchId: string; jobId: string }>(`/searches/${searchId}/profiles`, {
        method: 'POST',
        body: input,
      }),
    onSuccess: () => {
      // O detalhe volta a fazer polling assim que a coleta é enfileirada.
      void client.invalidateQueries({ queryKey: searchKeys.detail(searchId) });
      void client.invalidateQueries({ queryKey: profileKeys.candidates(searchId) });
    },
  });
}

export function useSavedProfiles() {
  return useQuery({
    queryKey: profileKeys.saved(),
    queryFn: () => apiRequest<{ data: SavedProfile[] }>('/profiles/saved'),
  });
}
